import { graphql } from '@teachino/shared-infrastructure';

export const addCoursesToTopicMutation = graphql(`
  mutation AddCoursesToTopic($topicId: String!, $courseIdsToAdd: [String!]!) {
    addTopicsToCourses(
      addTopicsCoursesInput: {
        topicIds: [$topicId]
        courseIds: $courseIdsToAdd
      }
    ) {
      done
      __typename
    }
  }
`);
